import React from 'react'

import { CheckBox, Icon } from '@st-operations/uikit/src/v2'

import IconReportDemographic from './svgs/report-demographic.js'
import IconReportAudienceTrend from './svgs/report-audience-trend.js'
import IconReportConsumerJourney from './svgs/report-consumer-journey.js'

import { OMM_REPORTS_STATUS_OPTIONS } from '../constants.js'

import './styles.scss'
import IconSheets from './svgs/icon-sheets.js'
import IconSlides from './svgs/icon-slides.js'
import classNames from 'classnames'

const Card = ({ Thumb, title, description, linkSheets, linkSlides, demoLink, classVariation }) => {
  return (
    <div
      className={classNames(
        'tab-insights-report__report',
        `tab-insights-report__report--${classVariation}`
      )}
    >
      {/* <CheckBox checked={true} /> */}
      <Thumb />
      <div>
        <p>{title}</p>
        <p>
          {description}
          {/* {!linkSheets && (
            <a
              href={demoLink}
              title="View demo report"
              target="_blank"
              rel="nofollow noreferrer noopener external"
            >
              Sample report
            </a>
          )} */}
        </p>
      </div>
      <a
        href={linkSheets ?? null}
        title="View report"
        target="_blank"
        rel="nofollow noreferrer noopener external"
      >
        <IconSheets />
        Google Sheet
      </a>
      <a
        href={linkSlides ?? null}
        title="View report"
        target="_blank"
        rel="nofollow noreferrer noopener external"
      >
        <IconSlides />
        Google Slides
      </a>
    </div>
  )
}

const InsightsReports = ({ data }) => {
  return (
    <div className="tab-insights-report">
      <div className="tab-insights-report__header">
        <h3 className="tab-insights-report__header-title">Insight Reports Beta</h3>
      </div>
      <div className="tab-insights-report__description">
        <p>
          ShareThis provided 3 kinds of reports according to your selected URLs to help summarize
          and gain insights. We provide Demographic Report, Audience Trend Report, and Customer
          Journey Report. Reports would be ready for you to view after the delivery, in both Slides
          and Sheet version. Select the requested report, and click deliver to proceed.
        </p>
        <Choose>
          <When condition={data.reportsStatus === OMM_REPORTS_STATUS_OPTIONS.REQUESTED}>
            <p style={{ color: '#13682B', fontWeight: 600 }}>
              Your reports were requested and will be generated soon
            </p>
          </When>
          <When condition={data.reportsStatus === OMM_REPORTS_STATUS_OPTIONS.GENERATING}>
            <p style={{ color: '#13682B', fontWeight: 600 }}>Generating Reports</p>
          </When>
          <When condition={data.reportsStatus === OMM_REPORTS_STATUS_OPTIONS.READY}>
            <p style={{ color: '#13682B', fontWeight: 600 }}>Reports Ready</p>
          </When>
          <Otherwise>
            <p style={{ color: '#13682B' }}>
              Click on <i>Generate Reports</i> button to start generating the reports
            </p>
          </Otherwise>
        </Choose>
      </div>
      <div className="tab-insights-report__reports">
        <Card
          title="Demographic Report"
          description="This report contains generated calculations about user demographics, including Age,
              Credit range, dwelling_type, education level, gender, etc."
          linkSheets={data?.reports?.demographic?.url}
          linkSlides={data?.reports?.demographic?.slidesUrl}
          demoLink="https://docs.google.com/spreadsheets/d/1SNWwNsXVzCbejiC2J7UiVgu8YsYnIvZb5-eNECzA0GI/edit#gid=1290265114"
          Thumb={IconReportDemographic}
          classVariation="demographic"
        />
        <Card
          title="Audience Trend Report"
          description="This report contains the calculated audience’s top domains, event and user counts on
              each domain, and the stream distribution."
          linkSheets={data?.reports?.audienceTrend?.url}
          linkSlides={data?.reports?.audienceTrend?.slidesUrl}
          demoLink="https://docs.google.com/spreadsheets/d/12MJLxUjH8gV9tG4TIy77MzmwerfxirWidr9vRBq5WPE/edit#gid=334410764"
          Thumb={IconReportAudienceTrend}
          classVariation="trend"
        />
        <Card
          title="Consumer Journey Report"
          description="This report contains the jogging experience of audiences from one domain to the other
              in 7 days, including the percentage comparison."
          linkSheets={data?.reports?.consumerJourney?.url}
          linkSlides={data?.reports?.consumerJourney?.slidesUrl}
          demoLink="https://docs.google.com/spreadsheets/d/1TBnqitLlhwalCr_qLp1X08XJcu2a-W-5ltpeC4Ro2dM/edit#gid=0"
          Thumb={IconReportConsumerJourney}
          classVariation="journey"
        />
      </div>
    </div>
  )
}

export default InsightsReports
